import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Form, InputField, ResetOnSuccess, Field, setErrors, FormError } from '../form';
import ActivateModalTrigger from '../billing/ActivateModalTrigger';
import AccountLimitsError from '../billing/AccountLimitsError';

import { first, keys } from 'lodash';

import copyToClipboard from '../../utils/copyToClipboard';


import {
  FormGroup,
  Button,
  Row,
  Col,
  ModalBody,
  ModalFooter
} from 'reactstrap';


import PixelSetsSelect from '../PixelSets/PixelSetsSelect';
import PreloadUniqueSlug from './PreloadUniqueSlug';
import CustomSlugInputField from './CustomSlugInputField';

import { UrlPreview, UrlScraper } from './urlScraper';
import setFieldData from 'final-form-set-field-data';

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faChevronRight from '@fortawesome/fontawesome-pro-light/faChevronRight';


const mapStateToProps = state => ({ pixelSets: state.pixelSets });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
};

const PixelSetsSelectAdapter = ({input})=>{
  return <PixelSetsSelect selectedIds={input.value} onChange={input.onChange} />
}


class LinkForm extends Component {
  
  constructor (props) {
    super(props);
    
    this.copyOnSubmit = this.copyOnSubmit.bind(this)
    this.toggleCopy = this.toggleCopy.bind(this);
    
    this.state = {
      tagsInput: false,
      initialValues: this.props.initialValues,
      copy: true
    };
  }
  
  toggleCopy () {
    this.setState({ copy: !this.state.copy })
  }
  
  copyOnSubmit (values){
    if (this.state.copy === false || !(values.slug || values.unique_slug))
      return 
    const shortUrl = "https://shor.by/" + (values.slug || values.unique_slug)
    copyToClipboard(shortUrl)
    // console.log("copy link", "https://shor.by/" + (values.slug || values.unique_slug));
  }
  
  componentWillMount (){
    this.setInitialValues(this.props)
  }
  
  componentWillReceiveProps (nextProps){
    if (this.props.pixelSets !== nextProps.pixelSets)
      this.setInitialValues(nextProps)
  }
  
  setInitialValues (props){
    const defaultPixelSetId = parseInt(first(keys(props.pixelSets)), 10);
    const { initialValues } = this.state// { ...(props.initialValues || {}), ...(this.state.initialValues || {}) }
    
    if ( defaultPixelSetId && (!initialValues || first(initialValues.pixel_set_ids) !== defaultPixelSetId) ){
      this.setState({
        initialValues: {...initialValues, pixel_set_ids: [defaultPixelSetId]}
      });
    }
  }
  
  toggleTags (e) {
    if (e)
      e.preventDefault();
    this.setState({tagsInput: !this.state.tagsInput})
  }
  
  render () {
    const { onSubmit, onSuccess, onFail, resetOnSuccess, catchSubmitEvent, modalWrappers } = this.props;
    const { initialValues } = this.state;
    
    const BodyWrapper = modalWrappers === true ? ModalBody : React.Fragment
    const FooterWrapper = modalWrappers === true ? ModalFooter : React.Fragment
    
    const isEdit = !!initialValues.id
    
    
    return (
      <Form
        {...{onSubmit, onSuccess, onFail, resetOnSuccess, initialValues}}
        mutators={{setFieldData, setErrors}}
        render={({ submitError, handleSubmit, submitting, pristine, values, form: {reset} }) => (
          
          <form className="link-form" onSubmit={(event) => {catchSubmitEvent && catchSubmitEvent(event); this.copyOnSubmit(values); handleSubmit(event);} } noValidate={true}>
            
            <BodyWrapper>
              {submitError && <FormError>{submitError}</FormError>}
              <ActivateModalTrigger />
              <AccountLimitsError />
              <UrlScraper urlField="url" dataField="meta" />
              
              <Row>
                <Col sm={12} md={6} className="form-group">
                  <InputField meta={{submitting}} name="url" type="text" placeholder="Type or paste a link (URL)" disabled={isEdit && initialValues.can_change_url === false} />
                </Col>
                <Col className="shorten-arrow d-none d-md-block">
                  <FA icon={faChevronRight} />
                </Col>
                <Col sm={12} md={6} className="form-group">
                  <PreloadUniqueSlug />
                  <CustomSlugInputField submitting={submitting} values={values} />
                </Col>
              </Row>
              
              <FormGroup>
                <UrlPreview name="meta" />
              </FormGroup>
              
              <FormGroup>
                <span className="small">Tracking Pixels:</span>  <Field 
                  name="pixel_set_ids"
                  component={PixelSetsSelectAdapter}
                />
              </FormGroup>
              
              {false && <pre>{JSON.stringify(values, 0, 2)}</pre>}
              
              <ResetOnSuccess enabled={resetOnSuccess || false} reset={reset} />
            </BodyWrapper>
            
            <FooterWrapper>
              {(values.unique_slug || values.slug) && (
                <label className="small">copy to clipboard  
                  <input type="checkbox" checked={this.state.copy} onChange={this.toggleCopy} />
                </label>)}
              
              {false && <div className="text-left">
                <a href="https://medium.com/@shorby" target="_blank" rel="noopener noreferrer">Pro tip: Branded links get 34% more clicks</a>    
              </div>}
              <div className="text-right">
                <Button
                  color="primary"
                  type="submit"
                  className="btn-wide upcase"
                  disabled={submitting}
                  onSubmit={this.copyOnSubmit}>
                  {isEdit ? 'Save' : 'Shorten'}
                </Button>
              </div>
            </FooterWrapper>
            
          </form>
        )}
      />
    )
  };
}

export default connect(mapStateToProps, matchDispatchToProps)(LinkForm);


// WEBPACK FOOTER //
// ./src/components/Links/form.js